<template>
	<div class="content_main">
		<div class="content_main_top">
			<a-input placeholder="请输入名称" class="a_input_self margin_self" v-model="queryParam.name" allowClear @keyup.enter.native="$refs.table.refresh(true)"/>
			<a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
			<a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
			<a-button v-if="addEnable" type="primary" icon="plus" @click="handleAdd">新建</a-button>
			<a-button type="danger" icon="delete" v-if="removeEnable && selectedRowKeys.length > 0" @click="delByIds(selectedRowKeys)">删除</a-button>
		</div>
		<div class="content_main_center_scroll" id="content_main_center_scroll">
			<s-table size="default" ref="table" rowKey="id" :rowSelection="rowSelection" :scroll="{  y: scroll_y - 50 }" :columns="columns"
			 :data="loadData">
				<span slot="action" slot-scope="text, record">
					<a v-if="editEnabel" @click="handleEdit(record.id)">编辑</a>
					<a-divider v-if="removeEnable" type="vertical" />
					<a v-if="removeEnable" @click="delByIds([record.id])">删除</a>
					<a-divider type="vertical" />
					<a v-if="releaseEnable" @click="deploy(record.id)">发布</a>
				</span>
			</s-table>
		</div>

		<a-modal :visible="modelVisible" title="Activiti工作流在线流程设计编辑" :footer="null" :width="1500" centered @cancel="modelCancel">
			<div style="position: relative; height: 100%">
				<iframe id="iframe" :src="modelerUrl" frameborder="0" width="100%" height="1000px" scrolling="auto"></iframe>
				<Spin fix size="large" v-if="modelerLoading"></Spin>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import {
		STable
	} from '@/components'
	// eslint-disable-next-line no-unused-vars
	import {
		getModelList,
		delModel,
		deploy,
		getmodelerBaseUrl
	} from '@/api/activiti'
	import {
		checkPermission
	} from '@/utils/permissions'
	const modelerBaseUrl = process.env.VUE_APP_MODEL_BASE_URL
	export default {
		name: 'ModelList',
		components: {
			STable,
		},
		data() {
			return {
				scroll_y: 150,
				visible: false,
				labelCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 5
					},
				},
				wrapperCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 16
					},
				},
				form: this.$form.createForm(this),
				mdl: {},
				permissions: [],
				// 高级搜索 展开/关闭
				advanced: false,
				// 查询参数
				queryParam: {},
				// 表头
				columns: [{
						title: '编号',
						dataIndex: 'id',
					},
					{
						title: '名称',
						dataIndex: 'name',
					},
					{
						title: '版本',
						dataIndex: 'version',
					},
					{
						title: '发布编号',
						dataIndex: 'deploymentId',
					},
					{
						title: '创建时间',
						dataIndex: 'createTime',
					},
					{
						title: '最后时间',
						dataIndex: 'lastUpdateTime',
					},
					{
						title: '操作',
						width: '150px',
						dataIndex: 'action',
						scopedSlots: {
							customRender: 'action'
						},
					},
				],
				// 加载数据方法 必须为 Promise 对象
				loadData: (parameter) => {
					return getModelList(Object.assign(parameter, this.queryParam))
				},
				modelVisible: false,
				selectedRowKeys: [],
				selectedRows: [],
				addEnable: checkPermission('activiti:modelList:save'),
				editEnabel: checkPermission('activiti:modelList:edit'),
				removeEnable: checkPermission('activiti:modelList:delete'),
				releaseEnable: checkPermission('activiti:modelList:release'),
			}
		},
		computed: {
			rowSelection() {
				return {
					selectedRowKeys: this.selectedRowKeys,
					onChange: this.onSelectChange,
					getCheckboxProps: (record) => ({
						props: {
							disabled: record.deploymentId, // Column configuration not to be checked
							name: record.name,
						},
					}),
				}
			},
		},
		filters: {},
		created() {},
		mounted() {
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $(".ant-table-header").height();
				}, 1000);
			})
		},
		methods: {
			onSelectChange(selectedRowKeys) {
				this.selectedRowKeys = selectedRowKeys
			},
			handleAdd() {
				// this.modelVisible = true
				getmodelerBaseUrl().then(res => {
					// modelerBaseUrl = http://192.168.0.204:8010
					this.modelerUrl = '/modeler.html?modelId=' + res + '&time=' + new Date().getTime()
					window.open(this.modelerUrl)
				})
			},
			handleEdit(id) {
				// this.modelVisible = true
				console.log(modelerBaseUrl)
				this.modelerUrl = modelerBaseUrl + '/modeler.html?modelId=' + id + '&time=' + new Date().getTime()
				window.open(this.modelerUrl)
			},
			handleOk() {
				this.$refs.table.refresh(true)
				console.log('handleSaveOk')
			},
			dataModal(dictType) {
				this.$refs.datamodal.show(dictType)
			},
			modelCancel() {
				this.modelVisible = false
				this.handleOk()
			},
			deploy(id) {
				// this.$message.error('演示环境无法操作')
				deploy(id).then((res) => {
					if (res.code === 200) {
						this.$message.success(`发布成功`)
						this.handleOk()
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			delByIds(ids) {
				delModel({
					ids: ids.join(',')
				}).then((res) => {
					if (res.code === 200) {
						this.$message.success(`删除成功`)
						this.handleOk()
					} else {
						this.$message.error(res.msg)
					}
				})
			},
		},
		watch: {
			/*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
		},
	}
</script>
